<button
	(click)="buttonSelected.emit(value)"
	*ngIf="!isSelected"
	mat-button
	mat-raised-button
	style="background-color: #f5f5f5"
>
	{{ label }}<span *ngIf="IS_NOT_NULL_OR_UNDEFINED(count)">&nbsp;({{ count }})</span>
</button>
<button
	(click)="buttonSelected.emit(value)"
	*ngIf="isSelected"
	class="focused-button"
	color="primary"
	mat-button
	mat-raised-button
>
	{{ label }}<span *ngIf="IS_NOT_NULL_OR_UNDEFINED(count)">&nbsp;({{ count }})</span>
</button>
